import * as React from 'react';
import IConfirmForm, { IUseConfirmForm, IUseConfirmFormState } from './IConfirmForm';
import { LightboxComponent } from '@company/components/LightboxComponent/LightboxComponent';

import * as style from './ConfirmFormStyle.module.scss'

export default class ConfirmForm extends React.Component<IConfirmForm> {

  closeLightbox = () => {
    this.props.closeLightbox();
  }

  actionFunction = () => {
    this.props.actionFunction();
  }

  render() {
    return (
      <LightboxComponent closePreview={this.props.closeLightbox} isVisible={this.props.isVisible} small={true}>
        <div className={style.confirmForm}>
          <h3 className={style.headline}>{this.props.values.headline}</h3>
          <p className={style.text}>{this.props.values.paragraph}</p>
          <div className={style.buttons}>
            <button className={style.cancelBtn} onClick={this.actionFunction} data-cy="confirm">
              {this.props.values.actionButton}
            </button>
            <button className={style.backBtn} onClick={this.closeLightbox} data-cy="back">
              Back
            </button>
          </div>
        </div>
      </LightboxComponent>
    );
  }
}

export const useConfirmForm = (): IUseConfirmForm => {
  const [confirmFormState, setConfirmFormState] = React.useState<IUseConfirmFormState>({
    isCalling: false,
    isDisplayed: false,
  });

  const updateState = (isCalling: boolean, isDisplayed: boolean) => {
    setConfirmFormState({
      isCalling,
      isDisplayed,
    });
  };

  return {
    confirmFormState,
    setConfirmFormState: updateState,
  };
};
